export class User {
  constructor(id?: number, first_name?: string, last_name?: string, email?: string, phone?: string) { }
}

export enum UserRolesEnum {
  account = "account",
  analyst = "analyst",
  salesperson = "salesperson",
  cfo = "CFO",
  affiliate = "affiliate",
  admin = "admin"
};

export enum EstimatedAnnualRevenueEnum {
  zero_to_two_million = "0-2 million",
  two_to_ten_million = "2-10 million",
  ten_million_or_more = "10 million +"
};